import { FormControl, FormGroup, Validators } from '@angular/forms';
import { harmonizedCodeValidator } from '../constraints/harmonized-code.validator';
import { WeightUnitEnum } from '../enum/weight-unit.enum';
import { CurrencyEnum } from '../enum/currency.enum';

export const createCommodityFormGroup = () => new FormGroup({
    description: new FormControl('', Validators.required),
    country: new FormControl('', Validators.required),
    quantity: new FormControl(1, Validators.min(1)),
    unitOfMeasure: new FormControl('EA'),
    province: new FormControl(''),
    netCost: new FormControl(0),
    markings: new FormControl(''),
    weight: new FormControl(0, Validators.min(0.01)),
    producer: new FormControl(''),
    harmonizedCode: new FormControl('0000.00.00.00', [Validators.required, harmonizedCodeValidator]),
    preference: new FormControl(''),
    weightUnit: new FormControl(WeightUnitEnum.KG),
    pieces: new FormControl(1, Validators.min(1)),
    price: new FormControl(0, Validators.min(0.01)),
    currency: new FormControl(CurrencyEnum.USD)
});
